"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const AttachFile_1 = __importDefault(require("@mui/icons-material/AttachFile"));
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const AttachmentField = ({ attributes, callbacks, SHOW_ALL, fieldActive, txn, focusField, }) => {
    const { classes } = useStyles();
    return (<styles_1.RegListItem {...attributes} tabIndex={null} className={classes.iconColumn} onClick={txn.attachments ? null : () => { var _a; return (_a = callbacks.handleMenu) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'addAttachments', txn); }}>
      {txn.attachments && (txn.attachments.length > 0) && SHOW_ALL &&
            <QIconButton_1.default aria-label="View Attachments" autoFocus={fieldActive} ref={fieldActive ?
                    (input) => {
                        focusField.current = input; // eslint-disable-line
                    } : null} focusRipple IconComponent={AttachFile_1.default} onClick={() => { var _a; return (_a = callbacks.handleMenu) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'viewAttachments', txn); }} tooltip={`Transaction has ${txn.attachments.length} attachment${txn.attachments.length > 1 ? 's' : ''}`} size="small-target"/>}
    </styles_1.RegListItem>);
};
exports.default = AttachmentField;
